/** Reads the most useful sentence from a failed API call, falling back to a plain message. */
export function readActionError(error: Error | null, fallback: string): string {
  if (!error) return fallback;
  const body = (error as Error & { body?: unknown }).body;
  if (typeof body !== 'object' || body === null || Array.isArray(body)) return fallback;
  const problem = body as Record<string, unknown>;
  if (typeof problem.detail === 'string' && problem.detail.trim() !== '') return problem.detail;
  if (typeof problem.title === 'string' && problem.title.trim() !== '') return problem.title;
  if (typeof problem.errors === 'object' && problem.errors !== null) {
    const first = Object.values(problem.errors as Record<string, unknown>).find(
      (value) => Array.isArray(value) && typeof value[0] === 'string',
    );
    if (Array.isArray(first) && typeof first[0] === 'string') return first[0];
  }
  return fallback;
}
